// extracted by mini-css-extract-plugin
module.exports = {"banner":"_1ab71cc","pagination":"_8a746d4"};